import { types } from '../actions/types';

export const ModelReducer = (
  state = {
    data: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.bmGetModels:
      return {
        ...state,
        data: action.payload,
      };
    case types.bmCreateModel:
      return {
        ...state,
        create: action.payload,
      };
    case types.bmUpdateModel:
      return {
        ...state,
        update: action.payload,
      };
    case types.bmDeleteModelById:
      return {
        ...state,
        deleteById: action.payload,
      };
    default:
      return state;
  }
};
